import src from "IMAGE";
export default { src, width: 268, height: 72, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQElEQVR42h3JMQoAMQgF0ZwykChYC1ZiIwieXP6yKaaZt9x9uhtV9cpMqCrMDCIyi5knIh7+894LIsI5B3vv+QC7piP/RR2pIAAAAABJRU5ErkJggg=="};
